export const InertiaMixin = {
    computed:{
        is_free_user() {
            return this.$page.props.user.package == 'free';
        },
        have_winning() {
            return this.$page.props.user.have_winning;
        },
        have_provider_filter() {
            return this.$page.props.user.have_provider_filter;
        },
        user() {
            return this.$page.props.user;
        }
    },
};

